const { createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = require('vue')

module.exports = function render (_ctx, _cache) {
    const path1 = _createVNode('path', {
        d: 'M13.4956 14.1718C15.8453 15.1659 18.1047 16.3408 20.5448 16.883C21.6293 17.0638 ' +
            '22.7137 17.1541 23.7982 17.1541V11.1895H22.8945C19.5507 11.1895 16.4779 12.9066 ' +
            '13.4956 14.1718Z',
        fill: '#6B7280'
    })

    const path2 = _createVNode('path', {
        d: 'M6.53731 16.0694C5.45282 15.979 4.36833 15.979 3.28385 15.979H0.84375V21.4918C0.' +
            '84375 22.4859 1.65712 23.2993 2.65123 23.2993H22.0816C23.0757 23.2993 23.8891 22' +
            '.4859 23.8891 21.4918V20.7688C21.5394 20.7688 19.0993 20.4977 16.9303 19.594C13.' +
            '4057 18.4191 10.2426 16.1598 6.53731 16.0694Z',
        fill: '#6B7280'
    })

    const path3 = _createVNode('path', {
        d: 'M21.9913 0.344727H2.65123C1.65712 0.344727 0.84375 1.15809 0.84375 2.15221V12.36' +
            '45C3.01273 12.3645 5.27207 12.4548 7.44105 12.2741C10.4234 12.003 13.0442 10.376' +
            '2 15.8458 9.29175C18.3763 8.20726 21.0875 7.57464 23.7987 7.66502V2.15221C23.798' +
            '7 1.15809 22.9854 0.344727 21.9913 0.344727Z',
        fill: '#6B7280'
    })

    const path4 = _createVNode('path', {
        d: 'M23.7987 11.1894V7.57446C21.0875 7.48408 18.3763 8.1167 15.8458 9.20119C13.0442 ' +
            '10.2857 10.4234 11.9124 7.44105 12.1835C5.27207 12.3643 3.01273 12.2739 0.84375 ' +
            '12.2739V15.9792H3.28385C4.36833 15.9792 5.45282 15.9792 6.53731 16.0696C10.2426 ' +
            '16.16 13.4057 18.4193 16.8399 19.5942C19.0089 20.4979 21.449 20.7691 23.7987 20.' +
            '7691V17.1541C22.7142 17.1541 21.6298 17.0637 20.5453 16.883C18.1052 16.3407 15.8' +
            '458 15.1659 13.4961 14.1718C16.4784 12.9065 19.5512 11.1894 22.895 11.1894H23.79' +
            '87Z',
        fill: 'white'
    })

    return (_openBlock(), _createBlock('svg', {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        fill: 'none',
        'aria-hidden': 'true'
    }, [
        path1,
        path2,
        path3,
        path4
    ]))
}
